// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import ElementUI from 'element-ui';
import axios from 'axios'
import VueAxios from 'vue-axios'
import $ from 'jquery'
import JQrecode from '../static/js/jquery.qrcode.min.js'

import '../static/css/eleme/index.css';
import '../static/css/swiper.css'

Vue.use(VueAxios, axios)
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
Vue.use(JQrecode)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js